import type { IntlShape } from "@formatjs/intl";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useMemo } from "react";
import type { ProjectReportPerson } from "../generated-axios-client";

const getPeopleColumns = (intl: IntlShape): ColumnsType<ProjectReportPerson> => [
  {
    key: "name",
    title: intl.formatMessage({ id: "work_order_totals_column_name" }),
    dataIndex: "name",
  },
  {
    key: "work_order_count",
    title: intl.formatMessage({ id: "work_order_totals_column_work_orders" }),
    align: "right",
    dataIndex: "work_order_count",
  },
];

type WorkOrderPeopleTableProps = {
  intl: IntlShape;
  people: ProjectReportPerson[] | undefined;
  loading: boolean;
};

export const WorkOrderPeopleTable = ({
  intl,
  people,
  loading,
}: WorkOrderPeopleTableProps) => {
  const peopleColumns = useMemo(() => getPeopleColumns(intl), [intl]);

  return (
    <Table<ProjectReportPerson>
      size="small"
      rowKey="user_id"
      columns={peopleColumns}
      dataSource={people ?? []}
      loading={loading}
      pagination={false}
      locale={{
        emptyText: intl.formatMessage({ id: "work_order_totals_no_people" }),
      }}
    />
  );
};
